import type { Video } from "@/types/video";

export const tvVideos: Video[] = [
  {
    id: "tv-01",
    title: "长安夜行",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20period%20drama%20poster%20of%20ancient%20Chinese%20city%20at%20night%20with%20glowing%20lanterns%20and%20red%20pavilions%2C%20a%20lone%20figure%20in%20robes%20walking%20a%20stone%20bridge%2C%20warm%20amber%20and%20deep%20blue%20tones%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-01&orientation=landscape",
    type: "tv",
    region: "华语",
    year: 2024,
    rating: 8.8,
    views: 1560000,
    updateDate: "2026-10-15",
    director: "裴照",
    actors: ["萧景琰", "林殊", "霓凰"],
    description:
      "大唐盛世之下暗藏汹涌，一桩离奇命案将禁军统领与江湖术士卷入朝堂漩涡。两人必须在十二个夜晚之内查明真相，才能阻止一场惊天阴谋。",
    tags: ["古装", "悬疑", "权谋"],
  },
  {
    id: "tv-02",
    title: "家族荣耀",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20of%20a%20grand%20mansion%20dining%20room%20with%20elegant%20family%20portrait%20and%20warm%20chandelier%20light%2C%20wealth%20and%20tension%20atmosphere%2C%20rich%20amber%20and%20deep%20brown%20tones%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-02&orientation=landscape",
    type: "tv",
    region: "华语",
    year: 2023,
    rating: 8.1,
    views: 1120000,
    updateDate: "2026-10-14",
    director: "霍岩",
    actors: ["顾承宇", "苏婉", "陆明"],
    description:
      "百年家族企业掌权人骤然离世，继承权之争一触即发。光鲜的豪门背后，是三代人埋藏的恩怨与秘密，每个人都戴着自己的面具。",
    tags: ["都市", "家族", "商战"],
  },
  {
    id: "tv-03",
    title: "都市迷情",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20urban%20romance%20drama%20poster%20of%20a%20couple%20on%20a%20city%20rooftop%20at%20dusk%20overlooking%20a%20glowing%20skyline%2C%20soft%20warm%20and%20cool%20blue%20contrast%2C%20tender%20cinematic%20mood%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=tv-03&orientation=landscape",
    type: "tv",
    region: "华语",
    year: 2024,
    rating: 7.8,
    views: 890000,
    updateDate: "2026-10-13",
    director: "温子谦",
    actors: ["贺宇", "程夏", "乔安"],
    description:
      "四段发生在同一座城市里的爱情故事彼此交织，每一次擦肩与重逢都藏着命运的安排。关于都市男女最真实的爱与迷茫。",
    tags: ["都市", "爱情", "群像"],
  },
  {
    id: "tv-04",
    title: "江湖再见",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20wuxia%20drama%20poster%20of%20a%20swordsman%20standing%20on%20a%20cliff%20over%20misty%20bamboo%20forest%20at%20dawn%2C%20flowing%20robes%2C%20green%20and%20amber%20tones%2C%20poetic%20martial%20arts%20atmosphere%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-04&orientation=landscape",
    type: "tv",
    region: "华语",
    year: 2022,
    rating: 8.5,
    views: 1230000,
    updateDate: "2026-10-12",
    director: "古风",
    actors: ["叶孤城", "沈青", "楚澜"],
    description:
      "退隐多年的剑客为寻一故人之诺重出江湖，却发现当年的恩怨早已化作新一代的纷争。刀光剑影之间，是快意恩仇，也是身不由己。",
    tags: ["武侠", "古装", "江湖"],
  },
  {
    id: "tv-05",
    title: "医学人生",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20medical%20drama%20poster%20of%20doctors%20in%20a%20bright%20hospital%20corridor%20walking%20with%20purpose%2C%20clean%20cool%20tones%20with%20warm%20accents%2C%20dedicated%20atmosphere%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-05&orientation=landscape",
    type: "tv",
    region: "华语",
    year: 2023,
    rating: 8.6,
    views: 980000,
    updateDate: "2026-10-11",
    director: "秦越",
    actors: ["顾亦然", "周医生", "唐护士"],
    description:
      "一群年轻医生在急诊科直面生死考验，在一次次抢救与抉择中理解医者仁心的重量。真实还原医院里的每一份坚守与温情。",
    tags: ["医疗", "职场", "剧情"],
  },
  {
    id: "tv-06",
    title: "刑侦笔记",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20drama%20poster%20of%20a%20detective%20studying%20a%20corkboard%20covered%20in%20photos%20and%20red%20strings%20in%20a%20dim%20office%2C%20cool%20grey%20and%20amber%20tones%2C%20tense%20mood%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-06&orientation=landscape",
    type: "tv",
    region: "华语",
    year: 2024,
    rating: 8.4,
    views: 1340000,
    updateDate: "2026-10-10",
    director: "黎川",
    actors: ["江砚", "周瑜", "许宁"],
    description:
      "天才刑警与法医搭档还原一桩桩疑难案件背后的真相。在冷峻的证据与复杂的人心之间，他们追寻的始终是那句迟来的公道。",
    tags: ["悬疑", "刑侦", "推理"],
  },
  {
    id: "tv-07",
    title: "豪门风云",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20of%20a%20skyscraper%20corporate%20boardroom%20with%20city%20views%2C%20elegant%20power%20suits%2C%20cool%20blue%20and%20warm%20gold%20contrast%2C%20ambitious%20atmosphere%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-07&orientation=landscape",
    type: "tv",
    region: "华语",
    year: 2022,
    rating: 7.6,
    views: 760000,
    updateDate: "2026-10-09",
    director: "钟晟",
    actors: ["傅锦", "江珊", "陆延"],
    description:
      "一场董事会政变让集团继承人之位悬而未决，昔日兄弟反目成仇。商场如战场，每一步棋都关乎整个家族的兴衰存亡。",
    tags: ["商战", "都市", "家族"],
  },
  {
    id: "tv-08",
    title: "山河故梦",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20historical%20drama%20poster%20of%20a%20vast%20mountain%20range%20and%20ancient%20city%20walls%20under%20golden%20sunset%2C%20epic%20scale%2C%20warm%20amber%20and%20deep%20green%20tones%2C%20majestic%20atmosphere%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-08&orientation=landscape",
    type: "tv",
    region: "华语",
    year: 2021,
    rating: 8.7,
    views: 1050000,
    updateDate: "2026-10-08",
    director: "关山",
    actors: ["燕云", "慕容雪", "李牧"],
    description:
      "乱世之中，一位出身寒微的将领与一位亡国公主并肩而行，在家国大义与儿女情长之间艰难抉择。山河依旧，故梦难醒。",
    tags: ["历史", "古装", "战争"],
  },
  {
    id: "tv-09",
    title: "青春纪事",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20youth%20drama%20poster%20of%20students%20on%20a%20school%20rooftop%20at%20golden%20hour%20with%20notebooks%20and%20bicycles%2C%20nostalgic%20warm%20tones%2C%20bittersweet%20atmosphere%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-09&orientation=landscape",
    type: "tv",
    region: "华语",
    year: 2023,
    rating: 8.0,
    views: 870000,
    updateDate: "2026-10-07",
    director: "夏栀",
    actors: ["林知夏", "周屿", "苏晚"],
    description:
      "一座南方小城的高中里，一群少年在升学压力与青春悸动中摸索前行。那些哭过笑过的日子，最终都成了回不去的纪念册。",
    tags: ["青春", "校园", "成长"],
  },
  {
    id: "tv-10",
    title: "暗战1943",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20spy%20thriller%20poster%20of%20a%20figure%20in%20a%20fedora%20hat%20under%20a%20streetlamp%20in%201940s%20city%20rain%2C%20noir%20mood%2C%20desaturated%20grey%20with%20amber%20accents%2C%20tense%20atmosphere%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-10&orientation=landscape",
    type: "tv",
    region: "华语",
    year: 2022,
    rating: 8.3,
    views: 940000,
    updateDate: "2026-10-06",
    director: "秦怀",
    actors: ["沈默", "苏晴", "代号夜莺"],
    description:
      "1943年的孤岛，一名潜伏在敌营深处的谍报员周旋于各方势力之间。一封加密电报改变了一切，信仰与牺牲在暗夜中熠熠生辉。",
    tags: ["谍战", "年代", "悬疑"],
  },
  {
    id: "tv-11",
    title: "岁月长歌",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20family%20saga%20poster%20of%20an%20old%20rural%20courtyard%20house%20through%20the%20seasons%2C%20aged%20wood%20and%20golden%20light%2C%20nostalgic%20warm%20tones%2C%20poignant%20atmosphere%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-11&orientation=landscape",
    type: "tv",
    region: "华语",
    year: 2020,
    rating: 8.9,
    views: 780000,
    updateDate: "2026-10-05",
    director: "路遥",
    actors: ["赵德海", "李秀兰", "孙建国"],
    description:
      "一个普通农家跨越五十年的悲欢离合，见证时代变迁下小人物的坚韧与温度。朴实无华的叙事，却字字动人，被誉为年度国民剧。",
    tags: ["年代", "家庭", "剧情"],
  },
  {
    id: "tv-12",
    title: "校园时光",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20school%20drama%20poster%20of%20a%20classroom%20with%20sunlight%20streaming%20through%20windows%20and%20chalk%20dust%20in%20the%20air%2C%20warm%20nostalgic%20tones%2C%20youthful%20bittersweet%20mood%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-12&orientation=landscape",
    type: "tv",
    region: "华语",
    year: 2024,
    rating: 7.9,
    views: 690000,
    updateDate: "2026-10-04",
    director: "杏子",
    actors: ["宋昱", "沈念", "陆时"],
    description:
      "转学生在高三这年闯入了原本平静的班级，也闯进了几个少年的人生。关于友情、暗恋与梦想，都藏在倒数计时的黑板角上。",
    tags: ["校园", "青春", "治愈"],
  },
  {
    id: "tv-13",
    title: "商海浮沉",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20business%20drama%20poster%20of%20a%20lone%20trader%20watching%20glowing%20stock%20charts%20on%20multiple%20screens%20at%20night%2C%20cool%20blue%20and%20amber%20data%20glow%2C%20intense%20atmosphere%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-13&orientation=landscape",
    type: "tv",
    region: "华语",
    year: 2023,
    rating: 7.7,
    views: 620000,
    updateDate: "2026-10-03",
    director: "陆沉舟",
    actors: ["江渔", "白鹭", "陈锋"],
    description:
      "从白手起家到身家亿万，一位创业者在资本浪潮中几度沉浮。当野心与底线反复博弈，能否守住最初的自己成为最大的考验。",
    tags: ["商战", "职场", "励志"],
  },
  {
    id: "tv-14",
    title: "正义之师",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20legal%20drama%20poster%20of%20a%20prosecutor%20team%20walking%20down%20a%20marble%20courthouse%20hall%2C%20dramatic%20backlight%2C%20cool%20grey%20and%20warm%20gold%20accents%2C%20determined%20mood%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-14&orientation=landscape",
    type: "tv",
    region: "华语",
    year: 2024,
    rating: 8.2,
    views: 810000,
    updateDate: "2026-10-02",
    director: "盛武",
    actors: ["顾律", "沈青禾", "方岩"],
    description:
      "一支年轻的检察官团队直面复杂案件与舆论压力，在法与情之间恪守良知。每一次出庭，都是对正义最朴素的坚持。",
    tags: ["律政", "职场", "剧情"],
  },
  {
    id: "tv-15",
    title: "甜蜜合约",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20comedy%20poster%20of%20a%20stylish%20couple%20standing%20back%20to%20back%20in%20a%20bright%20modern%20loft%2C%20playful%20chemistry%2C%20warm%20pink-free%20cream%20and%20amber%20tones%2C%20lighthearted%20mood%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-15&orientation=landscape",
    type: "tv",
    region: "华语",
    year: 2025,
    rating: 7.8,
    views: 1160000,
    updateDate: "2026-10-16",
    director: "甜豆",
    actors: ["林甜", "顾之", "许可可"],
    description:
      "一纸荒唐的婚约把两个毫无交集的人绑在了一起。从互看不顺眼到逐渐心动，假戏真做的过程里藏满了笑料与甜蜜。",
    tags: ["甜宠", "都市", "爱情"],
  },
  {
    id: "tv-16",
    title: "铁血军魂",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20military%20drama%20poster%20of%20soldiers%20standing%20in%20formation%20at%20sunrise%20with%20dust%20in%20the%20air%2C%20dramatic%20backlight%2C%20desaturated%20green%20and%20amber%20tones%2C%20disciplined%20mood%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-16&orientation=landscape",
    type: "tv",
    region: "华语",
    year: 2021,
    rating: 8.6,
    views: 900000,
    updateDate: "2026-10-01",
    director: "岳铮",
    actors: ["雷刚", "聂风", "秦锐"],
    description:
      "一群新兵在魔鬼训练营中淬炼成钢，从青涩少年成长为铁血战士。热血与泪水中，刻下的是永不磨灭的军魂与战友之情。",
    tags: ["军旅", "热血", "励志"],
  },
  {
    id: "tv-17",
    title: "大唐风华",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Tang%20dynasty%20drama%20poster%20of%20an%20opulent%20palace%20hall%20with%20colorful%20silk%20robes%20and%20golden%20ornaments%2C%20dancers%20in%20motion%2C%20rich%20amber%20and%20deep%20red-free%20maroon%20tones%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-17&orientation=landscape",
    type: "tv",
    region: "华语",
    year: 2023,
    rating: 8.4,
    views: 1020000,
    updateDate: "2026-09-30",
    director: "上官仪",
    actors: ["李隆基", "武媚", "白居易"],
    description:
      "盛世大唐的长安城里，一位才情卓绝的女子在宫廷与市井之间书写自己的人生。华服锦绣之下，是权力、才情与爱情的层层博弈。",
    tags: ["古装", "宫廷", "历史"],
  },
  {
    id: "tv-18",
    title: "推理笔记",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20drama%20poster%20of%20an%20old%20library%20with%20a%20magnifying%20glass%20and%20open%20cipher%20notebook%20under%20warm%20desk%20lamp%2C%20teal%20and%20amber%20tones%2C%20curious%20atmosphere%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-18&orientation=landscape",
    type: "tv",
    region: "华语",
    year: 2022,
    rating: 8.1,
    views: 720000,
    updateDate: "2026-09-28",
    director: "柯南道",
    actors: ["秦书", "沈理", "白薇"],
    description:
      "大学推理社的四个伙伴在校园与城市间破解一个个精巧的谜题。逻辑与人性的交锋中，一件尘封的旧案逐渐浮出水面。",
    tags: ["推理", "悬疑", "校园"],
  },
  {
    id: "tv-19",
    title: "重生之路",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20of%20a%20lone%20figure%20watching%20a%20sunrise%20from%20a%20city%20bridge%20after%20rain%2C%20symbolic%20new%20beginning%2C%20hopeful%20warm%20and%20cool%20contrast%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-19&orientation=landscape",
    type: "tv",
    region: "华语",
    year: 2024,
    rating: 7.9,
    views: 660000,
    updateDate: "2026-09-26",
    director: "程曦",
    actors: ["宋远", "何嘉", "叶澜"],
    description:
      "一场意外让成功人士跌入人生谷底，他带着重来一次的机会回到起点。这一次，他要弥补所有来不及说出口的遗憾与告别。",
    tags: ["都市", "奇幻", "励志"],
  },
  {
    id: "tv-20",
    title: "光芒万丈",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20music%20drama%20poster%20of%20a%20band%20performing%20on%20a%20stage%20with%20dramatic%20spotlights%20and%20crowd%2C%20silhouettes%20against%20warm%20orange%20glow%2C%20energetic%20atmosphere%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-20&orientation=landscape",
    type: "tv",
    region: "华语",
    year: 2023,
    rating: 7.7,
    views: 530000,
    updateDate: "2026-09-24",
    director: "崔璨",
    actors: ["江辰", "许光", "林漾"],
    description:
      "几个怀揣音乐梦想的年轻人在选秀舞台上相遇，从籍籍无名到站上万人舞台。梦想很贵，但热爱让他们愿意为之一战再战。",
    tags: ["音乐", "青春", "励志"],
  },
  {
    id: "tv-21",
    title: "风雪归人",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20winter%20drama%20poster%20of%20a%20lone%20traveler%20returning%20through%20snowfall%20to%20a%20warm-lit%20village%20house%2C%20soft%20golden%20windows%20against%20blue%20dusk%2C%20poignant%20atmosphere%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-21&orientation=landscape",
    type: "tv",
    region: "华语",
    year: 2021,
    rating: 8.3,
    views: 560000,
    updateDate: "2026-09-22",
    director: "白霜",
    actors: ["顾行", "温言", "陆雪"],
    description:
      "离家十年的游子在风雪之夜回到故乡，等待他的既有久别的亲情，也有未解的旧怨。归人一路，风雪兼程，终抵暖灯。",
    tags: ["家庭", "剧情", "治愈"],
  },
  {
    id: "tv-22",
    title: "都市夜归人",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20urban%20drama%20poster%20of%20a%20late-night%20convenience%20store%20glowing%20warm%20on%20a%20quiet%20street%2C%20lone%20customer%20and%20clerk%2C%20cool%20blue%20exterior%20and%20warm%20interior%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-22&orientation=landscape",
    type: "tv",
    region: "华语",
    year: 2022,
    rating: 8.0,
    views: 590000,
    updateDate: "2026-09-20",
    director: "夜河",
    actors: ["沈夜", "林晚", "周宁"],
    description:
      "一家二十四小时便利店里，深夜的顾客带着各自的心事来来去去。平凡的相遇与倾听，拼凑出这座城市最温暖的夜晚。",
    tags: ["都市", "群像", "治愈"],
  },
  {
    id: "tv-23",
    title: "王者之路",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20fantasy%20drama%20poster%20of%20an%20epic%20throne%20room%20with%20glowing%20runes%20and%20a%20lone%20crown%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20gold%20tones%2C%20majestic%20atmosphere%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-23&orientation=landscape",
    type: "tv",
    region: "华语",
    year: 2025,
    rating: 8.5,
    views: 1420000,
    updateDate: "2026-09-18",
    director: "玄墨",
    actors: ["君无涯", "苏九", "墨麒麟"],
    description:
      "背负宿命的少年从边陲小镇一路逆袭，在群雄逐鹿的乱世中崛起。权谋、热血与成长交织，一部荡气回肠的王者史诗。",
    tags: ["古装", "权谋", "热血"],
  },
  {
    id: "tv-24",
    title: "命运交响",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20of%20a%20grand%20concert%20hall%20orchestra%20mid-performance%20under%20warm%20golden%20spotlight%2C%20passionate%20conductor%2C%20dramatic%20scale%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-24&orientation=landscape",
    type: "tv",
    region: "欧美",
    year: 2023,
    rating: 8.7,
    views: 830000,
    updateDate: "2026-09-16",
    director: "马勒",
    actors: ["朱利安", "艾琳", "卡尔"],
    description:
      "一位天赋异禀却桀骜不驯的年轻指挥家，与一支走向没落的乐团相互救赎。在音符与人生之间，他们奏响了属于自己的命运交响。",
    tags: ["音乐", "剧情", "励志"],
  },
  {
    id: "tv-25",
    title: "星辰大海",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20drama%20poster%20of%20a%20space%20fleet%20sailing%20toward%20a%20distant%20star%20among%20nebulas%2C%20epic%20scale%2C%20deep%20navy%20and%20warm%20stellar%20glow%2C%20awe-inspiring%20atmosphere%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-25&orientation=landscape",
    type: "tv",
    region: "华语",
    year: 2024,
    rating: 8.2,
    views: 1180000,
    updateDate: "2026-09-14",
    director: "星河",
    actors: ["陆远航", "苏星辰", "顾则"],
    description:
      "人类史上最远的一次远征，一支舰队驶向未知星系寻找新的家园。浩瀚星海之间，勇气、牺牲与信念被推向极限。",
    tags: ["科幻", "冒险", "太空"],
  },
  {
    id: "tv-26",
    title: "医者仁心",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20medical%20drama%20poster%20of%20a%20surgeon%20washing%20hands%20under%20cold%20light%20before%20a%20difficult%20operation%2C%20sterile%20cool%20tones%20with%20warm%20skin%20accents%2C%20tense%20noble%20mood%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-26&orientation=landscape",
    type: "tv",
    region: "华语",
    year: 2022,
    rating: 8.5,
    views: 710000,
    updateDate: "2026-09-12",
    director: "仁泽",
    actors: ["何笙", "苏禾", "陆铭"],
    description:
      "一位外科主任在面对一次次生死抉择时，始终坚守着行医的底线。手术台上的分秒必争背后，是对生命最深沉的敬畏。",
    tags: ["医疗", "剧情", "剧情"],
  },
  {
    id: "tv-27",
    title: "江湖儿女",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20martial%20arts%20drama%20poster%20of%20two%20figures%20facing%20each%20other%20in%20a%20misty%20courtyard%20with%20falling%20blossoms%2C%20flowing%20robes%2C%20soft%20green%20and%20amber%20tones%2C%20emotional%20atmosphere%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-27&orientation=landscape",
    type: "tv",
    region: "华语",
    year: 2021,
    rating: 8.4,
    views: 640000,
    updateDate: "2026-09-10",
    director: "风清扬",
    actors: ["萧遥", "叶儿", "莫问"],
    description:
      "两个出身对立的武林后辈，在恩仇交织的江湖中彼此纠缠。刀剑易断，情义难舍，他们终究逃不过命运的相逢。",
    tags: ["武侠", "古装", "爱情"],
  },
  {
    id: "tv-28",
    title: "谍影迷城",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20espionage%20drama%20poster%20of%20a%20figure%20crossing%20a%20rainy%20european%20old%20town%20square%20at%20dusk%2C%20long%20coat%20and%20umbrella%2C%20noir%20cool%20tones%20with%20amber%20lamps%2C%20suspenseful%20mood%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-28&orientation=landscape",
    type: "tv",
    region: "欧美",
    year: 2023,
    rating: 8.6,
    views: 960000,
    updateDate: "2026-09-08",
    director: "莱昂",
    actors: ["维克多", "安娜", "米勒"],
    description:
      "冷战余晖下，一名双重间谍在情报网络中如履薄冰。每一次接头都可能是陷阱，而他必须查出潜伏在内部的真正内鬼。",
    tags: ["谍战", "悬疑", "惊悚"],
  },
  {
    id: "tv-29",
    title: "玫瑰之战",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20female-led%20drama%20poster%20of%20confident%20women%20in%20elegant%20suits%20strategizing%20in%20a%20modern%20office%2C%20sharp%20warm%20amber%20and%20cool%20grey%20tones%2C%20powerful%20mood%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-29&orientation=landscape",
    type: "tv",
    region: "华语",
    year: 2024,
    rating: 8.0,
    views: 880000,
    updateDate: "2026-09-06",
    director: "蔷薇",
    actors: ["林玫", "苏珊", "程可"],
    description:
      "三位来自不同背景的职场女性在一场并购案中狭路相逢。她们既是对手也是战友，在事业与生活的战场上并肩作战。",
    tags: ["职场", "都市", "女性"],
  },
  {
    id: "tv-30",
    title: "少年游",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20coming-of-age%20poster%20of%20young%20friends%20cycling%20along%20a%20riverside%20road%20at%20golden%20sunset%2C%20carefree%20joy%2C%20warm%20orange%20and%20green%20tones%2C%20nostalgic%20mood%2C%20highly%20detailed%20editorial%20cinematic%20composition&width=800&height=450&seq=tv-30&orientation=landscape",
    type: "tv",
    region: "华语",
    year: 2022,
    rating: 8.1,
    views: 600000,
    updateDate: "2026-09-04",
    director: "青衫",
    actors: ["周游", "陆屿", "夏天"],
    description:
      "六个少年在高中毕业那年踏上一场说走就走的旅行。沿途的风景与人情，成为他们青春里最难忘的一课，也定格了那段少年时光。",
    tags: ["青春", "成长", "公路"],
  },
];